import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as PostActions from "Data/posts/PostActions";

import PostEditor from "Components/PostEditor";
import PostScheduleModal from "Components/PostScheduleModal";

import { TrashIcon, ClockIcon, PencilAltIcon, ExternalLinkIcon, XCircleIcon } from "@heroicons/react/outline";
import ModalConfirm from "UI/ModalConfirm";
import Dropdown from "UI/Dropdown";
import ShareNowModal from "Components/ShareNowModal";

class PostCardSettingsMenu extends React.Component
{
    state = {
        dialog: null
    };

    static propTypes = {
        post: PropTypes.object.isRequired,
        integration: PropTypes.object,

        onDelete: PropTypes.func,
        onShare: PropTypes.func,
        onSchedule: PropTypes.func,
    };

    static defaultProps = {
        onDelete: () => {},
        onShare: () => {},
        onSchedule: () => {},
    };

    openDialog = (dialogName) => {
        this.setState({dialog: dialogName});
    };

    closeDialog = () => {
        this.setState({dialog: null});
    };

    render()
    {
        const { post } = this.props;

        if (post.status === 'shared') {
            return null;
        }

        let hasActiveIntegration = false;

        if (this.props.integration) {
            hasActiveIntegration = ! this.props.integration.disconnected_at;
        }

        const hasBeenScheduled = post.status === 'scheduled';

        return <>
            <Dropdown button={Dropdown.VerticalDotsButton} origin='tr'>
                <Dropdown.Item onClick={() => hasBeenScheduled ? this.openDialog('uneditable') : this.openDialog('edit')}>
                    <PencilAltIcon className='h-4 w-auto' />
                    <span>Edit</span>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => this.openDialog('schedule')} disabled={! hasActiveIntegration}>
                    <ClockIcon className='h-4 w-auto' />
                    <span>{hasBeenScheduled ? 'Reschedule' : 'Schedule'}</span>
                </Dropdown.Item>
                <Dropdown.Item onClick={this.props.onUnschedule} disabled={! hasActiveIntegration}>
                    <XCircleIcon className='h-4 w-auto' />
                    <span>Unschedule</span>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => this.openDialog('share')} disabled={! hasActiveIntegration}>
                    <ExternalLinkIcon className='h-4 w-auto' />
                    <span>Share now</span>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item danger onClick={() => this.openDialog('delete')}>
                    <TrashIcon className='h-4 w-auto' />
                    <span>Delete</span>
                </Dropdown.Item>
            </Dropdown>

            <ModalConfirm
                danger
                open={this.state.dialog === 'delete'}
                onConfirm={() => this.props.onDelete().then(this.closeDialog)}
                onClose={this.closeDialog}
            >
                Are you sure you wish to remove this Post?
            </ModalConfirm>

            <ModalConfirm
                danger
                open={this.state.dialog === 'uneditable'}
                onConfirm={() => this.props.onUnschedule().then(this.closeDialog)}
                onClose={this.closeDialog}
                title="Edit Scheduled Post"
                action="Unschedule"
            >
                To make changes to a post, first convert it to an unscheduled draft.
            </ModalConfirm>

            <ShareNowModal
                open={this.state.dialog === 'share'}
                onConfirm={() => this.props.onShare().then(this.closeDialog)}
                onClose={this.closeDialog}
            />

            <PostEditor
                open={this.state.dialog === 'edit'}
                onClose={this.closeDialog}
                post={this.props.post}
            />

            <PostScheduleModal
                open={this.state.dialog === 'schedule'}
                onClose={this.closeDialog}
                post={this.props.post}
            />
        </>;
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onDelete: () => dispatch(PostActions.removePost(ownProps.post.id)),
    onShare: () => dispatch(PostActions.sharePost(ownProps.post.id)),
    onUnschedule: () => dispatch(PostActions.unschedule(ownProps.post.id))
});

export default connect(
    null,
    mapDispatchToProps
)(PostCardSettingsMenu);
